import React from 'react';
import { Skeleton } from '@bb/elements-web';

const ContentSkeleton = () => (
  <>
    <div>
      <Skeleton
        title={{
          style: { height: 32, width: 150, marginBottom: 15 },
        }}
        paragraph={false}
      />
      <Skeleton
        title={{
          style: { height: 32, width: '100%', margin: 0 },
        }}
        paragraph={false}
      />
    </div>
    <Skeleton
      title={{
        style: { height: 17, width: 75 },
      }}
      paragraph={false}
    />
  </>
);

export default ContentSkeleton;
